<template>
  <div class="page-content original-dialog">
    <div class="custom-detail">
      <el-breadcrumb separator="/" class="egl-breadcrumb">
        <el-breadcrumb-item :to="{ path: '/News' }">{{ $locale("sideMenu.cinemaWebsite.news.title") }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $locale("cinemaWebsite.custom.dialog.title") }}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-form
        class="egl-elm egl-detail dialog-content"
        :model="form"
        :rules="formRules"
        ref="detailForm"
        label-position="top"
      >
        <el-col :span="24">
          <div class="form-module-tit">{{ $locale("cinemaWebsite.news.detail.create/edit") }}</div>
        </el-col>
        <el-row>
          <el-col :span="3">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.category')"
              prop="category"
            >
              <el-select v-model="form.category">
                <el-option
                  v-for="item in categoryList"
                  :label="item.title"
                  :key="item.value"
                  :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.title')"
              prop="title"
            >
              <el-input
                :placeholder="$locale('cinemaWebsite.news.form.title.plsInput')"
                v-model="form.title"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="4">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.subTitle')"
              prop="subTitle"
            >
              <el-input
                :placeholder="$locale('cinemaWebsite.news.form.subTitle.plsInput')"
                v-model="form.subTitle"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" align="middle">
          <el-col :span="8">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.hpPublish')"
              prop="hpPublish"
            >
              <el-radio-group v-model="form.hpPublish" @change="changeHpPublish_fn">
                <el-radio-button label="RELEASE">{{ $locale('cinemaWebsite.news.table.header.show') }}</el-radio-button>
                <el-radio-button label="PRIVATE">{{ $locale('cinemaWebsite.news.table.header.noHP') }}</el-radio-button>
                <el-radio-button label="SCHEDULED">{{ $locale('cinemaWebsite.news.table.header.scheduled') }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="7" v-if="form.hpPublish === 'SCHEDULED'">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.publishYear')"
              prop="publishTime"
            >
              <CommDatePicker
                v-model="form.publishTime"
                :value.sync="form.publishTime"
                width="100%"
                type="datetime"
                :showWeekly="true"
                :format="`yyyy-MM-dd HH:mm`"
                :pickerOptions="pickerOptions"
                popper-class="egl-datetime-minute"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.focusNews')"
              prop="focusNews"
            >
              <el-radio-group v-model="form.focusNews">
                <el-radio-button :label="true">ON</el-radio-button>
                <el-radio-button :label="false">OFF</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item
              :label="$locale('global.image')"
              prop="photoUrl"
            >
              <UploadContainer
                :imageList="[form.photoUrl]"
                @onSuccess="({response}) => uploadSuccess(response, 'photoUrl')"
                @onDelete="deletePhoto('photoUrl')"
              ></UploadContainer>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              :label="$locale('cinemaWebsite.news.table.header.content')"
              prop="content"
            >
              <editor v-model="form.content" :height="1200" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-row>
        <el-col :span="24" class="ta-r">
          <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ 
            actionType === "create" ? $locale("cinemaWebsite.news.form.submit") :
            $locale("global.confirm2")}}</el-button>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { getCategoryListService, updateNewsService, getNewsDetailService, createNewsService } from "@/helpers/service/api/cinemaWebsite";
import UploadContainer from "@/components/common/UploadContainer";
import Editor from "@/components/common/Tinymce/Rich";
import CommDatePicker from "@/components/common/CommDatePicker";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      form: {
        category: "notice",
        title: "",
        subTitle: "",
        hpPublish: "RELEASE",
        focusNews: false,
        photoUrl: "",
        content: "",
        publishTime: this.$moment().add(1, "minute").startOf("minute").valueOf(),
      },
      formRules: {
        category: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.category.required"),
            trigger: [ "blur" ]
          }
        ],
        title: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.title.required"),
            trigger: [ "blur" ]
          }
        ],
        hpPublish: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.hpPublish.required"),
            trigger: [ "blur" ]
          }
        ],
        focusNews: [
          {
            required: true,
            message: this.$locale("cinemaWebsite.news.form.focusNews.required"),
            trigger: [ "blur" ]
          }
        ],
        publishTime: [
          {
            validator: (rule, value, callback) => {
              if (this.form.hpPublish !== "SCHEDULED") {
                callback();
                return;
              }
              if (!value) {
                callback(new Error(this.$locale("cinemaWebsite.news.form.publishTime.required")));
                return;
              }
              callback();
            },
            trigger: [ "blur", "change" ]
          }
        ]
      },
      categoryList: [],
      tempPublishTime: 0,
      actionType: this.$route.path.indexOf("create") > -1 ? "create" : "edit"
    };
  },
  computed: {
    pickerOptions() {
      return {
        disabledDate: this.disabledDate
      };
    }
  },
  methods: {
    uploadSuccess(res, key) {
      if (res.success) {
        this.form[key] = res.data;
      }
    },
    deletePhoto(key) {
      this.form[key] = "";
    },
    disabledDate(time) {
      // 日付セルは 00:00 で渡されるため、日単位で比較して当日を選択可能にする
      return this.$moment(time).startOf("day").valueOf() < this.$moment().startOf("day").valueOf();
    },
    changeHpPublish_fn(val) {
      if (val === "SCHEDULED") {
        // 公開日時が未設定の場合のみ初期値を入れる（過去時刻の補正はしない）
        if (!this.form.publishTime) {
          this.form.publishTime = this.$moment().add(1, "minute").startOf("minute").valueOf();
        }
      } else {
        this.form.publishTime = this.tempPublishTime;
        this.$refs.detailForm.clearValidate("publishTime");
      }
    },
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText,
        callback: () => {
          this.$router.push("/news");
        }
      });
    },
    save_fn() {
      const requestParam = {
        ...this.form,
        content: this.$util.encodeBase64(this.form.content),
        cinemaId: window.localStorage.getItem("cinemaId"),
        // 予約公開は秒を 00 に切り捨てる。非予約公開时不覆盖原有公開日時，交由后端处理
        ...this.form.hpPublish === "SCHEDULED"
          ? { publishTime: this.$moment(this.form.publishTime).startOf("minute").valueOf() }
          : { publishTime: this.tempPublishTime || undefined }
      };
      this.$refs.detailForm.validate(valid => {
        if (valid) {
          if (this.actionType === "create") {
            createNewsService(requestParam).then(res => {
              /** 
               * data {} | null
               * 
              */
              this.requestScuessFn(res, this.$locale("global.createSuccessfully"));
            });
          } else {
            updateNewsService(requestParam).then(res => {
              this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
            });
          }
        } else {
          setTimeout(() => {
            const isError = document.getElementsByClassName("is-error");
            isError[0].querySelector("input").focus();
          }, 100);

          return false;
        }
      });
    },
  },
  created() {
    getCategoryListService({
      // accountId: window.localStorage.getItem("accountId"),
      cinemaId: window.localStorage.getItem("cinemaId"),
    }).then(res => {
      this.categoryList = [
        ...this.categoryList,
        ...res.data.list.map(item => ({
          title: item.title,
          value: item.category
        }))
      ];
    });
    if(this.$route.path.indexOf("update") > -1) {
      getNewsDetailService({ id: this.$route.params.id }).then(res => {
        this.tempPublishTime = res.data.publishTime;
        this.form = {
          ...res.data,
          content: this.$util.decodeBase64(res.data.content)
        };
      });
    }
  },
  components: {
    UploadContainer,
    Editor,
    CommDatePicker
  },
};
</script>